import { API_URLS } from "../Constants/api.constants";
import api from "./api";
import { errorHandling } from "./error.handling";

const basePath = `${API_URLS.MENUS}/Menus`;

export const menusService = {
    menus,
    menusCharts
};

async function menus() {
  try {
    const response = await api.get(`${basePath}`);

    const treated = errorHandling.handleResponse(response, "menuService.menus");
    if (treated) {
      return treated
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "menuService.menus");
    return false;
  }
}

async function menusCharts() {
  try {
    const response = await api.get(`${basePath}/dashboard`);

    const treated = errorHandling.handleResponse(response, "menuService.menusCharts");

    if (treated) {
      return treated
    }

    return null;
  } catch (error) {
    errorHandling.cathError(error, "menuService.menusCharts");
    return false;
  }
}